module.exports = __webpack_public_path__ + "static/img/pro-8.75fac1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pro-8.png
// module id = 3Qqp
// module chunks = 1